export default __webpack_public_path__ + "df5b8998cdb2fb33cc80cd9e5a92fe06.svg";